import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';

import { IWizardOptions } from '../../../models';
import { ITaskMeeting } from 'common-lib';

import * as _ from 'lodash';
@Component({
    selector: 'wizard-reschedule-picker',
    templateUrl: './reschedule-picker.component.html',
    styleUrls: ['./reschedule-picker.component.scss', '../../form-styles.scss']
})
export class ReschedulePickerComponent extends BaseComponent implements OnInit {
    public wizardOptions$: Observable<IWizardOptions>;
    public taskMeeting: ITaskMeeting;
    public scheduledTime = { start: '', end: '' };
    public selectedPicker: 'range' | 'specific' = 'range';
    public isGroupMeeting = true;

    constructor(private wizardService: WizardService) {
        super();
    }

    ngOnInit() {
        this.wizardOptions$ = this.wizardService.options$;
        this.scheduledTime = this.getScheduledTime(this.wizardService.options);
        // TODO: Update this when collective/group update is done to not rely on length for derived value
        this.isGroupMeeting = !!this.wizardService.selection.length;
    }

    ngAfterViewInit() {
        const componentsToHide = this.wizardService.config.componentsToHide;
        if (componentsToHide?.includes('DatePicker')) {
            this.updateView('specific');
        } else if (componentsToHide?.includes('SpecificDatePicker')) {
            this.updateView('range');
        }
    }

    private getScheduledTime(wizardOptions: IWizardOptions) {
        return {
            start: wizardOptions.meetingTime?.start || '',
            end: wizardOptions.meetingTime?.end || ''
        };
    }

    private updateView(type: 'range' | 'specific') {
        if (type === 'range') {
            this.selectedPicker = 'range';
            this.wizardService.updateOptions({ isSpecificTime: false });
            this.wizardService.updateDynamicVisibility({
                componentsToHide: ['SpecificDatePicker']
            });
        } else if (type === 'specific') {
            this.selectedPicker = 'specific';
            this.wizardService.updateOptions({ isSpecificTime: true });
            this.wizardService.updateDynamicVisibility({
                componentsToHide: ['DatePicker']
            });
        }
    }

    public handleSelect(type: 'range' | 'specific') {
        const initialMeeting = this.wizardService.initialMeeting;
        this.wizardService.updateOptions({ ...initialMeeting });
        this.updateView(type);
    }
}
